// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\ItineraryPoint\ApiItineraryPointVersion.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { Change, ChangeData, ChangeOptions } from 'data/models/Change';
import { Event, EventData, EventOptions } from 'data/models/Event';
import { ItineraryPointSelf, ItineraryPointSelfData, ItineraryPointSelfOptions } from 'data/models/ItineraryPointSelf';
import { ItineraryPointVersion as _ItineraryPointVersion, ItineraryPointVersionData as _ItineraryPointVersionData, ItineraryPointVersionOptions as _ItineraryPointVersionOptions } from 'data/models/ItineraryPointVersion';
import { PortCallSelf, PortCallSelfData, PortCallSelfOptions } from 'data/models/PortCallSelf';
import { ScheduleDate, ScheduleDateData, ScheduleDateOptions } from 'data/models/ScheduleDate';

// ItineraryPointVersionData is the class that ItineraryPointVersion serializes to/from
export interface ItineraryPointVersionData {
    ChangeId : number;
    Id : number;
	
    Change : ChangeData | null;
    EventsAbout : EventData[] | null;
    EventsReferencing : EventData[] | null;
    LocationId : number;
    NextVersion : _ItineraryPointVersionData[] | null;
    PortCall : PortCallSelfData | null;
    PortCallId : number;
    PrevChange : ChangeData | null;
    PrevChangeId : number | null;
    PrevVersion : _ItineraryPointVersionData | null;
    Self : ItineraryPointSelfData | null;
	
    Arrival : ScheduleDateData;
    Deleted : boolean;
    Departure : ScheduleDateData;
    ExtraDataJSON : string | null;
    Guid : /* GUID */ string;
    IsPortArrival : boolean;
    IsPortDeparture : boolean;
}

// ItineraryPointVersionOptions is the class which may be passed to the ItineraryPointVersion constructor to define optional initial data values
export interface ItineraryPointVersionOptions {
    ChangeId : number;
    Id : number;
	
    Change? : ChangeOptions | null;
    EventsAbout? : EventOptions[] | null;
    EventsReferencing? : EventOptions[] | null;
    LocationId? : number;
    NextVersion? : _ItineraryPointVersionOptions[] | null;
    PortCall? : PortCallSelfOptions | null;
    PortCallId? : number;
    PrevChange? : ChangeOptions | null;
    PrevChangeId? : number | null;
    PrevVersion? : _ItineraryPointVersionOptions | null;
    Self? : ItineraryPointSelfOptions | null;
	
    Arrival? : ScheduleDateOptions;
    Deleted? : boolean;
    Departure? : ScheduleDateOptions;
    ExtraDataJSON? : string | null;
    Guid? : /* GUID */ string;
    IsPortArrival? : boolean;
    IsPortDeparture? : boolean;
}

export class ItineraryPointVersion {
    public ChangeId : DataSignal<number>;
    public Id : DataSignal<number>;
	
    public Change : DataSignal<Change | null>;
    public EventsAbout : SDataArray<Event>;
    public EventsReferencing : SDataArray<Event>;
    public LocationId : DataSignal<number>;
    public NextVersion : SDataArray<_ItineraryPointVersion>;
    public PortCall : DataSignal<PortCallSelf | null>;
    public PortCallId : DataSignal<number>;
    public PrevChange : DataSignal<Change | null>;
    public PrevChangeId : DataSignal<number | null>;
    public PrevVersion : DataSignal<_ItineraryPointVersion | null>;
    public Self : DataSignal<ItineraryPointSelf | null>;
	
    public Arrival : ScheduleDate;
    public Deleted : DataSignal<boolean>;
    public Departure : ScheduleDate;
    public ExtraDataJSON : DataSignal<string | null>;
    public Guid : DataSignal<string>;
    public IsPortArrival : DataSignal<boolean>;
    public IsPortDeparture : DataSignal<boolean>;

    constructor();
    constructor(data : ItineraryPointVersionOptions);
    constructor(data: ItineraryPointVersionOptions | null = null) {
        this.ChangeId = jsonableObservable(S.value<number>(data && data.ChangeId !== undefined ? data.ChangeId : 0));
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
	    
        this.Change = S.value<Change | null>(null);
        this.EventsAbout = SArray<Event>([]);
        this.EventsReferencing = SArray<Event>([]);
        this.LocationId = jsonableObservable(S.value<number>(data && data.LocationId !== undefined ? data.LocationId : 0));
        this.NextVersion = SArray<_ItineraryPointVersion>([]);
        this.PortCall = S.value<PortCallSelf | null>(null);
        this.PortCallId = jsonableObservable(S.value<number>(data && data.PortCallId !== undefined ? data.PortCallId : 0));
        this.PrevChange = S.value<Change | null>(null);
        this.PrevChangeId = jsonableObservable(S.value<number | null>(data && data.PrevChangeId !== undefined ? data.PrevChangeId : null));
        this.PrevVersion = S.value<_ItineraryPointVersion | null>(null);
        this.Self = S.value<ItineraryPointSelf | null>(null);
	    
        this.Arrival = data && data.Arrival !== undefined ? new ScheduleDate(data.Arrival) : new ScheduleDate();
        this.Deleted = jsonableObservable(S.value<boolean>(data && data.Deleted !== undefined ? data.Deleted : false));
        this.Departure = data && data.Departure !== undefined ? new ScheduleDate(data.Departure) : new ScheduleDate();
        this.ExtraDataJSON = jsonableObservable(S.value<string | null>(data && data.ExtraDataJSON !== undefined ? data.ExtraDataJSON : null));
        this.Guid = jsonableObservable(S.value<string>(data && data.Guid !== undefined ? data.Guid : '00000000-0000-0000-0000-000000000000'));
        this.IsPortArrival = jsonableObservable(S.value<boolean>(data && data.IsPortArrival !== undefined ? data.IsPortArrival : false));
        this.IsPortDeparture = jsonableObservable(S.value<boolean>(data && data.IsPortDeparture !== undefined ? data.IsPortDeparture : false));
    }

    static key(obj : ItineraryPointVersion) {
        return obj.ChangeId() + '\u2618' + obj.Id();
    }
    
    static dataKey(obj : ItineraryPointVersionOptions) {
        return obj.ChangeId + '\u2618' + obj.Id;
    }

    static update(obj : ItineraryPointVersion, data : ItineraryPointVersionOptions) {
        S.freeze(() => {
            if (data.ChangeId !== undefined) obj.ChangeId(data.ChangeId);
            if (data.Id !== undefined) obj.Id(data.Id);
	        
            if (data.LocationId !== undefined) obj.LocationId(data.LocationId);
            if (data.PortCallId !== undefined) obj.PortCallId(data.PortCallId);
            if (data.PrevChangeId !== undefined) obj.PrevChangeId(data.PrevChangeId);
	        
            if (data.Arrival !== undefined) ScheduleDate.update(obj.Arrival, data.Arrival);
            if (data.Deleted !== undefined) obj.Deleted(data.Deleted);
            if (data.Departure !== undefined) ScheduleDate.update(obj.Departure, data.Departure);
            if (data.ExtraDataJSON !== undefined) obj.ExtraDataJSON(data.ExtraDataJSON);
            if (data.Guid !== undefined) obj.Guid(data.Guid);
            if (data.IsPortArrival !== undefined) obj.IsPortArrival(data.IsPortArrival);
            if (data.IsPortDeparture !== undefined) obj.IsPortDeparture(data.IsPortDeparture);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/ItineraryPointVersion.ts